import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { primaryShadow, useBreakpoint } from '@hivebrite/design-system/Theme';

import useFrameTheme from 'hb-react/shared/hooks/theme/useFrameTheme';

const FixedWrapper = ({ children }) => {
  const frameTheme = useFrameTheme();

  return (
    <Wrapper bg={frameTheme.backgroundColor} justifyContent="space-between">
      {children}
    </Wrapper>
  );
};

const StaticWrapper = ({ children }) => (
  <Box pt={6} justifyContent="space-between">
    {children}
  </Box>
);

const Navigation = ({ children }) => {
  const breakpoint = useBreakpoint();

  const isFixed = ['s', 'm'].includes(breakpoint);

  const Wrapper = isFixed ? FixedWrapper : StaticWrapper;

  return (
    <Wrapper>
      {children({
        isFixed,
        breakpoint,
      })}
    </Wrapper>
  );
};

export default Navigation;

const Wrapper = styled(Box)`
  justify-content: flex-end;
  padding: 16px 20px 16px 20px;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 10;
  ${primaryShadow}
`;
